export enum DataHooks {
  Title = 'Layout.Title',
}
